import { render } from "./Fitness.vue?vue&type=template&id=052e777f"
import script from "./Fitness.vue?vue&type=script&lang=js"
export * from "./Fitness.vue?vue&type=script&lang=js"

import "./Fitness.vue?vue&type=style&index=0&id=052e777f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__